
import { MessageCircle, Mail, MapPin, Phone } from "lucide-react";
import { useAdminSettings } from "@/hooks/useAdminSettings";

const Footer = () => {
  const { settings } = useAdminSettings();

  return (
    <>
      {/* Footer spacer for mobile - prevents sticky input overlap */}
      <div className="h-20 md:h-0"></div>
      
      <footer className="text-[#F4F4F4] hidden md:block" style={{ backgroundColor: 'rgba(27, 33, 57, 0.95)' }}>
        <div className="w-full">
          {/* Full-width divider */}
          <div className="w-full border-t-2 md:border-t-4 border-[#D7982B]"></div>
          
          {/* Logo and content below divider with reduced spacing */}
          <div className="container mx-auto px-4 md:px-8 py-3">
            <div className="text-center space-y-2">
              {/* Logo and tagline */}
              <div className="flex items-center justify-center space-x-2 mb-2">
                <div className="w-6 h-6 md:w-8 md:h-8 rounded-lg flex items-center justify-center relative" style={{ backgroundColor: '#D9992B' }}>
                  {/* Unique geometric design instead of T */}
                  <div className="relative w-4 h-4 md:w-5 md:h-5">
                    <div className="absolute inset-0 border-2 border-[#F4F4F4] rounded-sm transform rotate-45"></div>
                    <div className="absolute top-1/2 left-1/2 w-1.5 h-1.5 bg-[#F4F4F4] rounded-full transform -translate-x-1/2 -translate-y-1/2"></div>
                  </div>
                </div>
                <div className="flex flex-col text-left">
                  <span className="text-lg md:text-2xl font-bold uppercase">{(settings as any)?.website_name || 'Vintage Fiasco'}</span>
                  <span className="text-xs text-[#D9992B] font-medium -mt-1">{(settings as any)?.website_tagline || 'Vintage Wholesaler with ♡'}</span>
                </div>
              </div>
              
              <p className="text-[#F4F4F4] text-sm md:text-base mb-3">
                {(settings as any)?.footer_company_description || (settings as any)?.contact_address || 'Vintage Fiasco, Duisburg, Germany'}
              </p>
              
              {/* Contact info */}
              <div className="flex flex-col md:flex-row justify-center items-center space-y-2 md:space-y-0 md:space-x-6 mb-2">
                <div className="flex items-center">
                  <Phone className="w-4 h-4 mr-2 text-[#D9992B]" />
                  <span className="text-sm">{(settings as any)?.phone_number || '+49 15754767196'}</span>
                </div>
                <div className="flex items-center">
                  <Mail className="w-4 h-4 mr-2 text-[#D9992B]" />
                  <span className="text-sm">{(settings as any)?.email_address || 'hello@vintagefiasco.com'}</span>
                </div>
              </div>
              
              {/* Copyright */}
              <div className="text-[#747DA1] text-xs">
                <p>{(settings as any)?.footer_copyright_text || '© 2025 Vintage Fiasco. All rights reserved.'}</p>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
